import RichText from "@/components/RichText";
import NeedleEmblem from "../components/NeedleEmblem";
import { DiamondRule } from "../components/Primitives";

// Reprise de l'affiche du client : emblème centré (clamp(140px,18vw,210px),
// `mix-blend-mode: multiply` pour fondre le blanc d'un scan dans le crème),
// « HORAIRES » espacé + « d'ouverture » en italique, séparateur
// trait-losange-trait, grille 2 colonnes d'une ligne par jour, clôture.
export default function OpeningHoursSection({ props = {}, blocks = [] }) {
  const rows = (blocks || []).filter((b) => b.type === "day_row" && b.enabled !== false && b.props?.day);

  return (
    <section
      id="horaires"
      className="w-full px-5 md:px-11 border-t border-ink/[0.12] bg-sand scroll-mt-[90px]"
      style={{ paddingTop: "clamp(48px,7vw,84px)", paddingBottom: "clamp(48px,7vw,84px)" }}
    >
      <div className="max-w-[860px] mx-auto text-center">
        {props.emblem_image ? (
          <img
            src={props.emblem_image}
            alt="Aiguille et fil, emblème AEF Retouches"
            className="block mx-auto mb-[26px] h-auto [mix-blend-mode:multiply]"
            style={{ width: "clamp(140px,18vw,210px)" }}
          />
        ) : (
          <NeedleEmblem className="block mx-auto mb-[26px] h-auto text-ink" style={{ width: "clamp(140px,18vw,210px)" }} />
        )}
        <RichText
          as="h2"
          className="block font-display font-normal uppercase leading-none text-ink text-[clamp(26px,3.4vw,40px)] tracking-[0.34em] [text-indent:0.34em]"
          html={props.heading}
        />
        <RichText
          as="div"
          className="font-display italic text-[clamp(17px,2vw,22px)] text-ash mt-2"
          html={props.subheading}
        />
        <DiamondRule className="mt-[30px] mb-[34px]" />

        {rows.length > 0 && (
          <div className="grid [grid-template-columns:repeat(auto-fit,minmax(260px,1fr))] gap-x-14 text-left">
            {rows.map((b) => {
              const closed = String(b.props?.closed) === "true";
              return (
                <div
                  key={b.id}
                  data-block-key={b.id}
                  className="flex justify-between items-baseline gap-4 py-[15px] border-b border-ink/[0.14]"
                >
                  <span className="text-[11px] tracking-[0.22em] uppercase text-ink">{b.props?.day}</span>
                  <span className={`font-display text-[19px] ${closed ? "italic text-copper" : "text-ink"}`}>
                    {b.props?.hours}
                  </span>
                </div>
              );
            })}
          </div>
        )}

        <DiamondRule className="mt-[38px] mb-[26px]" />
        <RichText
          as="div"
          className="font-display italic text-[clamp(18px,2.2vw,24px)] text-ink"
          html={props.closing_line}
        />
        {props.thanks_line && (
          <div className="text-[10px] tracking-[0.3em] uppercase text-copper mt-[18px]">{props.thanks_line}</div>
        )}
      </div>
    </section>
  );
}
